import { render, staticRenderFns } from "./pendingTrainingsComp.vue?vue&type=template&id=f5bbfc2e"
import script from "./pendingTrainingsComp.vue?vue&type=script&lang=js"
export * from "./pendingTrainingsComp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports